/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/consistent-type-definitions */

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { InjectionToken } from '@angular/core';

export type MatDateFormats = {
  parse: {
    dateInput: any[];
    dateTimeInput: any[];
    monthYearInput: any[];
  };
  display: {
    dateInput: any;
    dateTimeInput: any;
    monthYearInput: any;
    monthLabel?: any;
    monthYearLabel: any;
    dateA11yLabel: any;
    monthYearA11yLabel: any;
  };
};

export const MAT_DATE_FORMATS = new InjectionToken<MatDateFormats>('mat-date-formats');
